import {
  Component,
  ComponentRef,
  EventEmitter,
  inject,
  Injector,
  Input,
  OnInit, Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { IOwnableEntity } from "../entities-list/entities-list.component";
import { UsersService, UserViewModel } from "../../../../../services/users.service";
import { ObjectsManagementDialogComponent } from "../../../objects-management-dialog/objects-management-dialog.component";
import { DialogService } from "../../../../../services/dialog.service";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { IOwnerManipulationService } from "../../../../../services/IOwnerManipulationService";
import { CompaniesService, CompanyModel } from 'app/services/companies.service';
import { ObjectsService } from 'app/services/objects.service';
import { ObjectModel } from 'app/models/ObjectModel';
import {ObjectLiteViewModel} from "../../../../../models/ObjectLiteViewModel";

@Component({
    selector: 'app-entities-list-orchestrator',
    templateUrl: './entities-list-orchestrator.component.html',
    styleUrls: ['./entities-list-orchestrator.component.css'],
    standalone: false
})
export class EntitiesListOrchestratorComponent {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;
  public myEntities: ObjectLiteViewModel[] = [];
  public targetEntities: ObjectLiteViewModel[] = [];
  public currentCompany: CompanyModel;
  public IsCopyControl: boolean = false;
  public companies: CompanyModel[];
  public selectedCompanyId: number = 0;

  @Input('currentUser')
  set onCurrentUserSet(val) {
    this.currentUser = val;
    this.FillCurrentEntities();
  }
  public currentUser: UserViewModel;
  public users: UserViewModel[] = [];
  @Input()
  public targetUser: UserViewModel;
  private dialogService: DialogService;
  private translateService: TranslateService;
  protected manipulationService: IOwnerManipulationService;
  private companyService = inject(CompaniesService);
  private objectService = inject(ObjectsService);

  public constructor(protected injector: Injector) {
    this.dialogService = injector.get(DialogService);
    this.translateService = injector.get(TranslateService);
    this.companyService.getCompanies().subscribe(companies => {
      this.companies = companies.filter(x => x.Id != this.currentUser.CompanyId);
      this.currentCompany = companies.find(x => x.Id == this.currentUser.CompanyId)
      this.selectedCompanyId = this.companies[0]?.Id;
      this.FillTargetEntities();
    });
  }

  public GetTargetCompany() {
    return this.companies?.find(x => x.Id == this.selectedCompanyId);
  }

  private FillCurrentEntities() {
    if (this.currentUser)
      this.getMyEntities().subscribe(entities => { this.myEntities = entities; })
  }
  public FillTargetEntities() {
    this.objectService.GetByCompanyId(this.selectedCompanyId).subscribe(entities => {
      this.targetEntities = [];
      let myIds = this.myEntities.map(x => x.Id);
      for (let index = 0; index < entities.length; index++) {
        const element = entities[index];
        if (!myIds.includes(element.Id)) {
          this.targetEntities.push(element);
        }
      }
    });
  }

  GetCurrentUserName() {
    if (!this.currentUser)
      return "";
    return this.currentUser.Name;
  }

  showUserSelectionDialog() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.users;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {
      this.objectsListDialog.instance.objects.forEach(user => { if (user && user.IsChecked) this.targetUser = user; });
      this.FillTargetEntities();
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => { });
    this.objectsListDialog.instance.open();
  }

  protected getMyEntities(): Observable<ObjectLiteViewModel[]> {
    if (this.currentUser.Id != 0)
      return this.manipulationService.GetUserObjects(this.currentUser.Id);
  }

  protected shareWithCurrentUser() {
    this.manipulationService.ShareObject(this.selectedCompanyId, this.currentUser.Id, this.targetEntities.filter(e => e.IsChecked).map(e => e.Id))
      .subscribe(() => {
        this.targetEntities.filter(e => e.IsChecked).forEach(e => {
          e.IsChecked = false;
          let item = Object.assign({}, e);
          if (this.myEntities.filter(x => x.Id == item.Id).length == 0)
            this.myEntities.unshift(item);
        });
      })
  }

  public deleteFromCurrentUser() {
    const arr: Array<number> = [];
    this.myEntities
      .filter(e => e.IsChecked)
      .forEach(e => { arr.push(e.Id); });
    this.stopSharingWithCurrentUser(arr);
  }

  public deleteFromTargetUser() {
    const arr: Array<number> = [];
    this.targetEntities
      .filter(e => e.IsChecked)
      .forEach(e => { arr.push(e.Id); });
    this.stopSharingWithTargetUser(arr);
  }

  public stopSharingWithCurrentUser(ids: Array<number>) {
    let message = this.translateService.instant("Delete X items?").replace("X", ids.length);
    if (ids.length == 0 || !confirm(message)) return;
    this.manipulationService.StopSharing(this.selectedCompanyId, this.currentUser.Id, ids)
      .subscribe(() => this.FillCurrentEntities());
  }

  public stopSharingWithTargetUser(ids: Array<number>) {
    let message = this.translateService.instant("Delete X items?").replace("X", ids.length);
    if (ids.length == 0 || !confirm(message)) return;
    this.manipulationService.StopSharing(this.selectedCompanyId, this.targetUser.Id, ids)
      .subscribe(() => { this.FillTargetEntities() });
  }
}

